import * as React from 'react'
import DropdownMenuLink from './DropdownMenuLink'
import DropdownMenuContainer from './DropdownMenuContainer'
import PropTypes from 'prop-types'

const LanguageDropDownMenu = ({ dropDown, onMenuLinkClick, setDropDown }) => {
  return (
    <DropdownMenuContainer selectedDropDown={dropDown} dropDownIndex={5} setDropDown={setDropDown}>
      <DropdownMenuLink onClick={onMenuLinkClick} className="" to="/spanish/">
        Spanish
      </DropdownMenuLink>
      <DropdownMenuLink onClick={onMenuLinkClick} className="" to="/russian/">
        Russian
      </DropdownMenuLink>
      <DropdownMenuLink onClick={onMenuLinkClick} className="" to="/portuguese/">
        Portuguese
      </DropdownMenuLink>
      <DropdownMenuLink onClick={onMenuLinkClick} className="" to="/locations/">
        Areas we Serve
      </DropdownMenuLink>
    </DropdownMenuContainer>
  )
}
LanguageDropDownMenu.propTypes = {
  dropDown: PropTypes.number,
  onMenuLinkClick: PropTypes.func,
  setDropDown: PropTypes.func,
}

export default LanguageDropDownMenu
